import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import KeyboardArrowUpIcon from 'components/common/Icon/KeyboardArrowUpIcon';
import KeyboardArrowDownIcon from 'components/common/Icon/KeyboardArrowDownIcon';
import styles from './styles.module.sass';

const DIRECTION = {
  desc: 'desc',
  asc: 'asc'
};

class TableSortLabel extends PureComponent {
  handlerOnClick = (e) => {
    const {onClick, direction} = this.props;
    if (onClick) {
      function getNextDirection (direction) {
        switch (DIRECTION) {
          case direction.asc:
            return direction.desc;
          case direction.desc:
            return direction.desc;
          default:
            return direction.asc;
        }
      }

      const nextDirection = getNextDirection(direction);
      onClick(nextDirection);
    }
  };

  render() {
    const {children, className: clName, direction, active, style: stl} = this.props;
    function renderDirectionIcon() {
      if (!active) return null;
      switch (direction) {
        case DIRECTION.asc:
          return <KeyboardArrowUpIcon className={styles.directionIconBox} />;
        case DIRECTION.desc:
          return <KeyboardArrowDownIcon className={styles.directionIconBox}/>;
        default:
          return null;
      }
    }

    return (
      <div style={stl} onClick={this.handlerOnClick} className={cx(clName, styles.tableSortLabel)}>
        {children}
        {renderDirectionIcon()}
      </div>
    )
  }
}

TableSortLabel.defaultProps = {};

TableSortLabel.direction = DIRECTION;

TableSortLabel.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.any,
  active: PropTypes.bool,
  direction: PropTypes.oneOf([DIRECTION.asc, DIRECTION.desc]),
  onClick: PropTypes.func
};

export default TableSortLabel;


// WEBPACK FOOTER //
// ./src/components/common/Table/TableSortLabel.jsx